import { TMobileSignupForm } from './form';
import { TScreenDef } from '../screens/types';

export type TResumeResult =
  | { status: 'pending' }
  | { status: 'screen'; index: number }
  | { status: 'complete' };

const isWalkable = (screen: TScreenDef): boolean => screen.stage !== 'Offer';

const findFirstUnansweredIndex = (
  form: TMobileSignupForm,
  registry: TScreenDef[],
): number =>
  registry.findIndex(
    (screen) => isWalkable(screen) && !screen.isAnswered(form),
  );

// The furthest screen the current answers permit the user to reach. stateKey-agnostic
// so the nav guard behaves identically pre- and post-mint (resume owns the mint-gated
// pending/complete states; this owns the "how far forward is allowed" ceiling).
export const furthestAllowedIndex = (
  form: TMobileSignupForm,
  registry: TScreenDef[],
): number => {
  const index = findFirstUnansweredIndex(form, registry);
  return index === -1 ? registry.length - 1 : index;
};

export const firstUnansweredScreen = (
  form: TMobileSignupForm,
  registry: TScreenDef[],
  signupStatus: { stateKey?: string; isSeeded: boolean },
): TResumeResult => {
  if (!signupStatus.stateKey) return { status: 'screen', index: 0 };

  if (!signupStatus.isSeeded) return { status: 'pending' };

  const index = findFirstUnansweredIndex(form, registry);

  return index === -1 ? { status: 'complete' } : { status: 'screen', index };
};
